// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
  100% {
    transform: rotateX(360deg);
  }
}
.not_found_main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.not_found_main .not__found {
  align-self: center;
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.not_found_main .not__found h1 {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: #bf1a1a;
  font-size: 12.5rem;
  letter-spacing: 0.1em;
  margin: 0.025em 0;
  text-shadow: 0.05em 0.05em 0 rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}
@media (max-width: 30rem) {
  .not_found_main .not__found h1 {
    font-size: 8.5rem;
  }
}
.not_found_main .not__found h1 span {
  animation: spin 2s alternate infinite linear;
  display: inline-block;
}
.not_found_main .not__found h2 {
  text-align: center;
  text-transform: uppercase;
  color: #bf1a1a;
}
.not_found_main .not__found .button {
  margin: 2% auto;
  background: #fff;
  font-size: 14px;
  margin-top: 30px;
  padding: 16px 20px;
  border-radius: 26px;
  border: 1px solid #bf1a1a;
  text-transform: uppercase;
  font-weight: 700;
  align-items: center;
  max-width: 270px;
  width: 10vw;
  color: #1d1d1d;
  box-shadow: 0px 2px 2px #bf1a1a;
  cursor: pointer;
  transition: 0.2s;
  text-decoration: none;
  text-align: center;
}
.not_found_main .not__found .button:active, .not_found_main .not__found .button:focus, .not_found_main .not__found .button:hover {
  border-color: #bf1a1a;
  outline: none;
}
@media (max-width: 690px) {
  .not_found_main .not__found {
    width: 90%;
  }
  .not_found_main .not__found .button {
    width: 40vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/animations/notFound/notfound.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE;IACE,0BAAA;EADF;AACF;AAIA;ECgCI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDjCF,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACF;AACE;EACE,kBAAA;EACA,UAAA;ECsBA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ADpBJ;AAHI;ECyCA,aAAA;EACA,mBAAA;EACA,6BAAA;EDzCE,cCtBE;EDuBF,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gDAAA;EACA,mBAAA;AAON;AANM;EARF;IASI,iBAAA;EASN;AACF;AARM;EACE,4CAAA;EACA,qBAAA;AAUR;AAPI;EACI,kBAAA;EACA,yBAAA;EACA,cCvCA;ADgDR;AAPI;EACG,eAAA;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,cCrDE;EDsDF,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AASR;AARQ;EAGI,qBC/DJ;EDgEI,aAAA;AAQZ;AAHE;EACE;IACI,UAAA;EAKN;EAJM;IACI,WAAA;EAMV;AACF","sourcesContent":["@import \"../../styles/variables.scss\";\n\n@keyframes spin {\n  100% {\n    transform: rotateX(360deg);\n  }\n}\n\n.not_found_main {\n  @include columnStack;\n  width: 100vw;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  .not__found {\n    align-self: center;\n    width: 30%;\n    @include columnStack;\n    h1 {\n      @include rowEven;\n      color: $rtRed;\n      font-size: 12.5rem;\n      letter-spacing: 0.1em;\n      margin: 0.025em 0;\n      text-shadow: 0.05em 0.05em 0 rgba(0, 0, 0, 0.25);\n      white-space: nowrap;\n      @media (max-width: 30rem) {\n        font-size: 8.5rem;\n      }\n      span {\n        animation: spin 2s alternate infinite linear;\n        display: inline-block;\n      }\n    }\n    h2{\n        text-align: center;\n        text-transform: uppercase;\n        color: $rtRed;\n    }\n    .button{\n       margin: 2% auto;\n        background: #fff;\n        font-size: 14px;\n        margin-top: 30px;\n        padding: 16px 20px;\n        border-radius: 26px;\n        border: 1px solid $rtRed;\n        text-transform: uppercase;\n        font-weight: 700;\n        align-items: center;\n        max-width: 270px;\n        width: 10vw;\n        color: $rtBlack;\n        box-shadow: 0px 2px 2px $rtRed;\n        cursor: pointer;\n        transition: 0.2s;\n        text-decoration: none;\n        text-align: center;\n        &:active,\n        &:focus,\n        &:hover {\n            border-color: $rtRed;\n            outline: none;\n        }\n\n    }\n  }\n  @media (max-width: $mobile){\n    .not__found{\n        width: 90%;\n        .button{\n            width: 40vw;\n        }\n    \n    }\n  }\n}\n","$rtRed: #bf1a1a;\n$rtBlack: #1d1d1d;\n$warning: #ff8808;\n$success: #00a74f;\n\n//Brand Colours\n$hr_dark_blue: #012748;\n$hr_blue: #0f4e6f;\n$hr_gold: #b66d2d;\n$hr_orange: #fe9816;\n$hr_yellow: #fede8c;\n\n//mobile breaks\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnEnd {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin shadow {\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
